import {
  DatePickerWithInput,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useImageCertification from "./useImageCertification";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import FilterButton from "../../Global/FilterButton";
import Filter from "./Filter";
import Style from "./imageCertificationList.module.scss";
import {Table} from "../../Global/Table";

const ImageCertificationList = () => {
  const {
    date,
    imageCertificationState,
    imageCertificationList,
    isFetching,
    isLoading,
    tableFields,
    showEditModal,
    paginationOptions,
    refetch,
    getRow,
    handleDateChange,
    handleSearch,
    handleEditColumnsClick,
    updateImageCertificationFields,
    handleClearClick,
    handlePageSize,
    handlePagination,
    handleSort,
    handleDownloadClick,
    handleFilter,
    handleFilterClose,
    filterCount,
  } = useImageCertification();

  return (
    <div>
      <HeadingGroup
        title={"Shop Certificate"}
        className={`pro-mb-4`}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="pro-d-flex pro-items-start pro-gap-4 pro-mb-4">
          <div className="col-auto">
            <SearchFilters
              onSearchInput={handleSearch}
              showActions={true}
              handleActionClick={handleEditColumnsClick}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              // showClearFilters
              handleClear={handleClearClick}
              searchInputProps={{ value: imageCertificationState?.search, placeholder: "Search Gli Number" }}
            />
          </div>
          <div className="col-auto">
            <DatePickerWithInput
              CalendarOutlineIcon={
                <span className="material-symbols-outlined">
                  calendar_month
                </span>
              }
              range={true}
              initialValue={date}
              onDateChange={handleDateChange}
              datePickerProps={"this_year"}
            ></DatePickerWithInput>
          </div>
          <div className="col-auto">
            <FilterButton
              onClick={handleFilter}
              filterCount={filterCount}
              className={Style.filter_btn}
            />
          </div>
        </div>
        <Table
          multiSelect={false}
          data={imageCertificationList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          getRow={getRow}
          SortIcon={<FaSort />}
          handleSort={handleSort}
          clear={imageCertificationState.clearSelection}
          loading={isFetching}
          perpage={imageCertificationState?.currentPageSize}
          assignable={true}
          showCheckBox={false}
          assignText={"Download"}
          assignIcon={
            <span className="material-symbols-outlined">download</span>
          }
          handleAssign={handleDownloadClick}
        />
        {imageCertificationList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={imageCertificationState?.currentPage}
            totalPageCount={Math.ceil(
              imageCertificationList?.data?.total_count /
                imageCertificationState.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={imageCertificationList?.data?.fields}
              moduleId={imageCertificationList?.data?.module_id}
              updateData={updateImageCertificationFields}
            />
          </div>
        </ModalLayout>

        <OffCanvasLayout
          show={imageCertificationState?.showFilter}
          handleClose={handleFilterClose}
          title={"Filter"}
          closeicon={<span className="material-symbols-outlined"> close </span>}
        >
          <Filter />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default ImageCertificationList;
